export const MAIN_NODE_ID = 'mainNode';

export const mainNode = {
  _id: 'mainNode',
  name: 'Mainline',
  ghosted: false,
  ardoq: { 'entity-type': null },
  representationData: null,
  cssClassNames: null,
};
